import React, { ForwardedRef } from "react";
import styled from "@emotion/styled";
import { Button, IconButton, ButtonProps } from "@kaltura/ds-react-components";
import { useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { useTheme } from "@kaltura/mediaspace-shared-styled";

const StyledButton = styled(Button)({
    minWidth: "fit-content",
});

/**
 * `Add New` menu button, for kaf pages - my media and BSE.
 */
export const AddNewMenuButton = React.forwardRef((props: ButtonProps, ref: ForwardedRef<HTMLButtonElement>) => {
    const { startIcon, ...rest } = props;
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <>
            {smallScreen && (
                <IconButton {...rest} variant={"pill"} ref={ref}>
                    {startIcon}
                </IconButton>
            )}
            {!smallScreen && <StyledButton {...rest} startIcon={startIcon} ref={ref} />}
        </>
    );
});
export default AddNewMenuButton;
